export default "__VITE_ASSET__PD3kVRYQ__"